import axios from "axios";
import { authHeader } from "./auth-headers";

//Building the complete URL for all the calls
const buildURL = (url) => {
  return `${process.env.REACT_APP_BASE_URL}${url}`;
};

//Function for building header for calls
const buildHeaders = (auth, isFormData) => {
  let headers = {};

  if (isFormData) {
    headers = {
      "Content-Type": "multipart/form-data",
    };
  } else {
    headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }

  if (auth === true) {
    headers = { ...headers, ...authHeader() };
  }

  return headers;
};

//Creating delete request header for calls
const getRequest = (url, auth = true, token = null) => {
  const completeUrl = buildURL(url);
  const headers = buildHeaders(auth);
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//Creating delete request header for calls
const deleteRequest = (url, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "DELETE",
    headers: buildHeaders(auth),
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//Creating post request header for calls
const postRequest = (url, dataObj = {}, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "POST",
    headers: buildHeaders(auth),
    data: dataObj,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//Creating put request header for calls
const putRequest = (url, dataObj, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(auth),
    data: JSON.stringify(dataObj),
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

const formDataPostRequest = (url, dataObj, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "POST",
    headers: buildHeaders(auth, true),
    data: dataObj,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

const formDataPutRequest = (url, dataObj, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(auth, true),
    data: dataObj,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

export {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  formDataPostRequest,
  formDataPutRequest,
};
